import React from 'react';
import { Flex, Typography } from 'antd';
import QuoteSymbol from '../../QuoteSymbol';

const { Text } = Typography;

interface CommentProps {
  comment: string
}

const Comment = function ({ comment }: CommentProps) {
  return (
    <Flex wrap={false} gap="small">
      <QuoteSymbol />
      <Text italic type="secondary">{comment}</Text>
    </Flex>
  );
};

export default Comment;
